(function () {
    'use strict';
    /*
     * Copyright (c) 2014-20 In Hand Health.
     * All rights reserved.
     */

    /**
     * A service for interacting with the server REST API.
     * @ngdoc service
     * @memberOf ihh-common-web
     * @name RestResources
     */
    angular
        .module('ihh-common-web')
        .service('RestResources', RestResources);

    RestResources.$inject = ['$resource', 'appConfig', '$sce', 'UserSvc', 'Utilities', 'ResourceMaterialsFactory'];

    function RestResources($resource, appConfig, $sce, UserSvc, Utilities, ResourceMaterialsFactory) {
        var apiPath = '';
        var app = '';
        var queryLimit;
        var self = this;

        this.getCommonHost = function () {
            return appConfig.commonHost;
        };

        this.getDefaultExerciseThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/no-exercise-media.png';
            return thumb;
        };

        this.getDefaultVideoThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/no-exercise-media.png';
            return thumb;
        };

        this.getDefaultClinicThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/no-clinic.jpg';
            return thumb;
        };

        this.getDefaultPersonThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/no-avatar.jpg';
            return thumb;
        };

        this.getDefaultResourceMaterialThumbnailUrl = function (type) {
            var thumb;

            if (type === 'video/mp4' || type === 'mov/mp4') {
                thumb = self.getDefaultResourceMaterialVideoThumbnailUrl();
            }
            else if (type === 'application/pdf') {
                thumb = self.getDefaultResourceMaterialPdfThumbnailUrl();
            }
            else if (type === 'url') {
                thumb = self.getDefaultResourceMaterialUrlThumbnailUrl();
            }
            else {
                thumb = self.getCommonHost() + '/assets/no-exercise-media.png';
            }

            return thumb;
        };

        this.getDefaultResourceMaterialVideoThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/default-video-thumbnail.png';
            return thumb;
        };

        this.getDefaultResourceMaterialPdfThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/default-pdf-thumbnail.png';
            return thumb;
        };

        this.getDefaultResourceMaterialUrlThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/default-url-thumbnail.png';
            return thumb;
        };

        this.getLightResourceMaterialVideoThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/light-video-thumbnail.png';
            return thumb;
        };

        this.getLightResourceMaterialPdfThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/light-pdf-thumbnail.png';
            return thumb;
        };

        this.getLightResourceMaterialUrlThumbnailUrl = function () {
            var thumb = self.getCommonHost() + '/assets/light-url-thumbnail.png';
            return thumb;
        };

        var appendQueryParam = function (url, name, value) {
            if (angular.isUndefined(url)) {
                return url;
            }
            if (url.indexOf('?') > -1) {
                return url + '&' + name + '=' + value;
            }
            else {
                return url + '?' + name + '=' + value;
            }
        };

        var appendSession = function (url) {
            var user = UserSvc.get();
            return user.session ? appendQueryParam(url, 'sessionId', user.session.id) : url;
        };

        var appendRedirect = function (url) {
            return appendQueryParam(url, 'redirect', true);
        };

        self.appendMediaParams = function (url) {
            return appendRedirect(appendSession(url));
        };

        /**
         * Returns an error message string, given an error object returned from a REST method.
         * @ngdoc method
         * @name getErrorMsg
         * @memberOf ihh-common-web.RestResources
         * @param {type} err the error object from the REST API call
         * @returns {String} a string explaining the error
         */
        this.getErrorMsg = function (err) {
            // The message is sometimes on property:data, and other times on property:data.message
            if (err && err.data) {
                if (err.data.message) {
                    return err.data.message;
                }
                else if (err.status === 401) { // special case, override message
                    return 'You are not signed in. Please sign in again.';
                }
                else {
                    return err.data;
                }
            }

            if (err && err.statusText) {
                return err.statusText;
            }

            if (err && err.status === 0) {
                return 'Could not reach server';
            }

            if (angular.isString(err)) {
                return err;
            }

            return 'Unknown error communicating with server';
        };

        /**
         * Defines a common procedure for reporting a REST error to the user.
         * @ngdoc method
         * @memberOf ihh-common-web.RestResources
         * @name reportRestError
         * @param {String} msgPrefix a string prefix for the error message
         * @param {Obect} err the error object from the REST call
         */
        this.reportRestError = function (msgPrefix, err) {
            var msg = self.getErrorMsg(err);
            Utilities.modalWait(msgPrefix + ': \n' + msg, 'OK', 'Error');
        };

        /**
         * Sets the REST API path prefix. Must be called before other methods in this service will work.
         * @ngdoc method
         * @name setApiPath
         * @memberOf ihh-common-web.RestResources
         * @param prefix the prefix to set; do not include the trailing slash
         */
        this.setApiPath = function (prefix) {
            apiPath = prefix;
        };

        /**
         * Returns the previously set REST API path prefix.
         * @ngdoc method
         * @name setApiPath
         * @memberOf ihh-common-web.RestResources
         */
        this.getApiPath = function () {
            return apiPath;
        };

        /**
         * TODO
         * @ngdoc method
         * @name setApp
         * @memberOf ihh-common-web.RestResources
         */
        this.setApp = function (appIn) {
            app = appIn;
        };

        /**
         * TODO
         * @ngdoc method
         * @name setQueryLimit
         * @memberOf ihh-common-web.RestResources
         */
        this.setQueryLimit = function (queryLimitIn) {
            queryLimit = queryLimitIn;
        };

        /**
         * TODO
         * @ngdoc method
         * @name getQueryLimit
         * @memberOf ihh-common-web.RestResources
         */
        this.getQueryLimit = function () {
            return queryLimit;
        };

        /* RESOURCES */

        /**
         * TODO
         * @ngdoc method
         * @name getVersionResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getRestVersionResource = function () {
            return $resource(apiPath + '/version/');
        };

        this.getSessionResource = function () {
            return $resource(apiPath + '/sessions/:id');
        };

        /**
         * TODO
         * @ngdoc method
         * @name getSelfResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getSelfResource = function (personId) {
            return $resource(apiPath + '/persons/' + personId, {}, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getNewObjectResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getNewObjectResource = function () {
            return $resource(apiPath + '/new-objects/');
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPersonsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPersonsResource = function () {
            return $resource(apiPath + '/persons/:personId', {}, {
                query: {
                    isArray: false,
                    params: {
                        limit: queryLimit
                    }
                },
                update: {
                    method: 'PUT'
                },
                search: {
                    url: apiPath + '/persons/search',
                    method: 'GET',
                    isArray: false
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getStaffResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getStaffResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/staff/:staffId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPersonAddressesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPersonAddressesResource = function (personId) {
            return $resource(apiPath + '/persons/' + personId + '/addresses/:addressId', {}, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPersonPhonesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPersonPhonesResource = function (personId) {
            return $resource(apiPath + '/persons/' + personId + '/phones/:phoneId', {}, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getPersonEmailsResource = function (personId) {
            return $resource(apiPath + '/persons/' + personId + '/emails/:emailId', {}, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getPersonPasswordResource = function (personId) {
            return $resource(apiPath + '/persons/' + personId + '/password', {}, {
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getPasswordResetResource = function () {
            return $resource(apiPath + '/passwords', {}, {}); // save only
        };

        this.getClinicsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/clinics/:clinicId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getBrandedAppsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/ops/branded-apps/:brandedAppId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getPatientBrandedAppsResource = function () {
            return $resource(apiPath + '/branded-apps/:brandId', {}, {});
        };

        /**
         * Gets a resource for clinic groups.
         */
        this.getClinicGroupsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/clinic-groups/:groupId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Gets a resource for querying clinic group clinics.
         */
        this.getClinicGroupsClinicListResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/clinic-groups/:groupId/clinics', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Gets a resource for clinic specialties.
         */
        this.getClinicSpecialtiesResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/clinic-specialties/:specialtyId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /*
         * Gets a resource for querying clinic specialty clinics.
         */
        this.getClinicSpecialtiesClinicListResource = function (specialtyId) {
            var params = {
                limit: queryLimit,
                specialtyId: specialtyId
            };
            return $resource(apiPath + '/clinic-specialties/:specialtyId/clinics', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource for interacting with patients endpoints.
         * @param {string} clinicId the ID of the clinic of the patient
         * @param {string} associateProfessionalId if provided, the clinic professional ID of the associate authenticating
         */
        this.getPatientsResource = function (clinicId, associateProfessionalId) {
            var params = {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/patients/:patientId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource used to POST a transfer request.
         * @param {String} clinicId the clinic ID of the patient
         */
        this.getPatientTransferResource = function (clinicId) {
            var params = {};

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/patients/:patientId/transfer', params);
        };

        /**
         * Returns a resource used to POST a re-welcome request.
         * @param {String} clinicId the clinic ID of the patient
         * @param {String} patientId the ID of the patient
         */
        this.getPatientReWelcomeResource = function (clinicId, patientId) {
            var params = {};

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId,
                    patientId: patientId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/patients/:patientId/welcome', params);
        };

        /**
         * Returns a resource used to POST a create episode from campaign request.
         * @ngdoc method
         * @name getPatientCampaignEpisodeResource
         * @memberOf ihh-common-web.RestResources
         * @param {String} clinicId the clinic ID of the patient
         * @param {String} patientId the ID of the patient
         */
        this.getPatientCampaignEpisodeResource = function (clinicId, patientId) {
            var params = {};

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId,
                    patientId: patientId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/patients/:patientId/campaign-episode', params);
        };

        this.getLeadsResource = function (clinicId, associateProfessionalId) {
            var params = {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                limit: queryLimit,
                lead: true
            };

            return $resource(apiPath + '/clinics/:clinicId/patients/:patientId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getClinicAlertTargets = function (clinicId) {
            var params = {
                limit: queryLimit
            };

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            return $resource(apiPath + '/clinics/:clinicId/alert-targets', params, {
                get: {
                    isArray: true
                }
            });
        };

        this.getClinicAlertResource = function (clinicId, alertId) {
            var params = {
                limit: queryLimit
            };

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            if (angular.isDefined(alertId)) {
                angular.extend(params, {
                    alertId: alertId
                });
            }

            return $resource(apiPath + '/clinics/:clinicId/alerts/:alertId', params, {
                save: {
                    method: 'POST'
                },
                query: {
                    isArray: false
                },
                get: {
                    isArray: false
                }
            });
        };

        this.getOpsAlertTargets = function () {
            return $resource(apiPath + '/alert-targets', {}, {
                get: {
                    isArray: true
                }
            });
        };

        this.getOpsAlertResource = function () {
            return $resource(apiPath + '/alerts/:alertId', {}, {
                save: {
                    method: 'POST'
                },
                query: {
                    isArray: false
                },
                get: {
                    isArray: false
                }
            });
        };

        this.getClinicAlertReceiverResource = function (clinicId, staffId, alertId) {
            var params = {
                limit: queryLimit
            };

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            if (angular.isDefined(staffId)) {
                angular.extend(params, {
                    staffId: staffId
                });
            }

            if (angular.isDefined(alertId)) {
                angular.extend(params, {
                    alertId: alertId
                });
            }

            return $resource(apiPath + '/clinics/:clinicId/staff/:staffId/alerts/:alertId', params, {
                get: {
                    isArray: true
                },
                acknowledge: {
                    url: apiPath + '/clinics/:clinicId/staff/:staffId/alerts/:alertId/acknowledgement',
                    method: 'PUT'
                },
                receipt: {
                    url: apiPath + '/clinics/:clinicId/staff/:staffId/alerts/:alertId/receipt',
                    method: 'PUT'
                }
            });
        };

        this.getOpsAlertReceiverResource = function (staffId, alertId) {
            var params = {
                limit: queryLimit
            };

            if (angular.isDefined(staffId)) {
                angular.extend(params, {
                    staffId: staffId
                });
            }

            if (angular.isDefined(alertId)) {
                angular.extend(params, {
                    alertId: alertId
                });
            }

            return $resource(apiPath + '/staff/:staffId/alerts/:alertId', params, {
                get: {
                    isArray: true
                },
                acknowledge: {
                    url: apiPath + '/staff/:staffId/alerts/:alertId/acknowledgement',
                    method: 'PUT'
                },
                receipt: {
                    url: apiPath + '/staff/:staffId/alerts/:alertId/receipt',
                    method: 'PUT'
                }
            });
        };

        this.getAlertReceiverResource = function (id, clinicId) {
            var resource;

            if (app === 'admin') {
                resource = this.getOpsAlertReceiverResource(id);
            }
            else if (app === 'therapist') {
                resource = this.getClinicAlertReceiverResource(clinicId, id);
            }

            return resource;
        };

        this.getAlertsResource = function (personId) {
            return $resource(apiPath + '/persons/:personId/alerts', {
                personId: personId
            }, {
                query: {
                    isArray: false
                },
                acknowledge: {
                    url: apiPath + '/persons/:personId/alerts/:alertId/acknowledgement',
                    method: 'PUT'
                }
            });
        };

        /*
         * Returns a resource for clinic staff.
         */
        this.getClinicStaffResource = function (clinicId) {
            var params = {
                limit: queryLimit
            };
            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/staff/:staffId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /*
         * Returns a resource for clinic preset messages.
         */
        this.getClinicPresetMessagesResource = function (clinicId, presetMessageId) {
            var params = {
                limit: queryLimit
            };

            if (clinicId) {
                params.clinicId = clinicId;
            }

            if (presetMessageId) {
                params.presetMessageId = presetMessageId;
            }

            return $resource(apiPath + '/clinic/clinics/:clinicId/preset-messages/:presetMessageId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /*
         * Returns a resource for clinic associates.
         */
        this.getClinicAssociatesResource = function (clinicId) {
            var params = {
                limit: queryLimit
            };
            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/associates/:associateId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /*
         * Returns a resource for clinic associates, retrieved by associated professional (for permissions).
         */
        this.getClinicAssociateByProfessionalResource = function (clinicId) {
            var params = {
            };
            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/associate-by-professional/:staffId/:otherClinicId', params, {
            });
        };

        /*
         * Returns a resource for clinic associate professionals (the clinic staff from another clinic that can be assigned as
         * associates in this clinic).
         */
        this.getClinicAssociateProfessionalsResource = function (clinicId) {
            var params = {
                limit: queryLimit
            };
            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }
            return $resource(apiPath + '/clinics/:clinicId/associate-professionals', params, {
                query: {
                    isArray: false
                }
            });
        };

        this.getEpisodesOfCareResource = function (clinicId, associateProfessionalId) {
            var params = {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /*
         * An endpoint to update the glance information for the episode.
         */
        this.getEpisodesOfCareGlanceResource = function (clinicId, associateProfessionalId) {
            var params = {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId
            };

            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/glance', params, {
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getTherapistMessagesResource = function (clinicId, therapistId) {
            var params = {
                limit: queryLimit
            };
            angular.extend(params, {
                clinicId: clinicId,
                therapistId: therapistId
            });
            return $resource(apiPath + '/clinics/:clinicId/therapists/:therapistId/messages', params, {
                query: {
                    isArray: false
                }
            });
        };

        /*
         * The resource for getting therapist unread message counts.
         */
        this.getTherapistnreadMessageCountResource = function (clinicId, therapistId, episodeId) {
            var params = {
                clinicId: clinicId,
                therapistId: therapistId,
                episodeId: episodeId
            };

            return $resource(apiPath + '/clinics/:clinicId/therapists/:therapistId/messages/:episodeId/count', params);
        };

        /**
         * Returns a resource object for interacting with episode message endpoints.
         * @ngdoc method
         * @name getEpisodeOfCareMessagesResource
         * @memberOf ihh-common-web.RestResources
         * @param {string} clinicId the clinic of the episode messages
         * @param {string} episodeId the episode of the episode messages
         * @param {string} associateProfessionalId if provided, the clinic professional ID of the associate accessing the messages
         */
        this.getEpisodeOfCareMessagesResource = function (clinicId, episodeId, associateProfessionalId) {
            var params = {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                episodeId: episodeId,
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/messages/:messageId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource for the clinical message thread endpoint.
         * @ngdoc method
         * @name getEpisodeOfCareClinicalMessagesResource
         * @memberOf ihh-common-web.RestResources
         * @param clinicId the ID of the clinic
         * @param episodeId the ID of the episode
         */
        this.getEpisodeOfCareClinicalMessagesResource = function (clinicId, episodeId, associateProfessionalId) {
            var params = {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                episodeId: episodeId,
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/clinical-messages/:messageId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getEpisodeOfCareMessagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getEpisodeOfCareMessageReceiptsResource = function (clinicId, episodeId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/message-receipts/:messageId', {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                episodeId: episodeId
            }, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource that can be used to interact with clinic episode of care message images.
         * @ngdoc method
         * @name getEpisodeOfCareMessageImagesResource
         * @memberOf ihh-common-web.RestResources
         * @param {string} clinicId the ID of the clinic
         * @param {string} episodeId the ID of the episode
         * @param {string} messageId the ID of the message
         */
        this.getEpisodeOfCareMessageImagesResource = function (clinicId, episodeId, messageId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/messages/:messageId/media/:name', {
                clinicId: clinicId,
                episodeId: episodeId,
                associateProfessionalId: associateProfessionalId,
                messageId: messageId
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource that can be used to interact with clinic episode of care message audio.
         * @ngdoc method
         * @name getEpisodeOfCareMessageAudioResource
         * @memberOf ihh-common-web.RestResources
         * @param {string} clinicId the ID of the clinic
         * @param {string} episodeId the ID of the episode
         * @param {string} messageId the ID of the message
         */
        this.getEpisodeOfCareMessageAudioResource = function (clinicId, episodeId, messageId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/messages/:messageId/media/:name', {
                clinicId: clinicId,
                episodeId: episodeId,
                associateProfessionalId: associateProfessionalId,
                messageId: messageId
            });
        };

        /**
         * Returns a resource that can be used to interact with clinic episode of care message video.
         * @ngdoc method
         * @name getEpisodeOfCareMessageVideoResource
         * @memberOf ihh-common-web.RestResources
         * @param {string} clinicId the ID of the clinic
         * @param {string} episodeId the ID of the episode
         * @param {string} messageId the ID of the message
         */
        this.getEpisodeOfCareMessageVideoResource = function (clinicId, episodeId, messageId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/messages/:messageId/media/:name', {
                clinicId: clinicId,
                episodeId: episodeId,
                associateProfessionalId: associateProfessionalId,
                messageId: messageId
            });
        };

        /**
         * Returns a resource that can be used to interact with clinic episode of care message pdf.
         * @ngdoc method
         * @name getEpisodeOfCareMessagePdfResource
         * @memberOf ihh-common-web.RestResources
         * @param {string} clinicId the ID of the clinic
         * @param {string} episodeId the ID of the episode
         * @param {string} messageId the ID of the message
         */
        this.getEpisodeOfCareMessagePDFResource = function (clinicId, episodeId, messageId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/messages/:messageId/media/:name', {
                clinicId: clinicId,
                episodeId: episodeId,
                associateProfessionalId: associateProfessionalId,
                messageId: messageId
            });
        };

        /**
         * Returns a resource that can be used to interact with clinic episode of care message STL.
         * @ngdoc method
         * @memberOf ihh-common-web.RestResources
         * @param {string} clinicId the ID of the clinic
         * @param {string} episodeId the ID of the episode
         * @param {string} messageId the ID of the message
         */
        this.getEpisodeOfCareMessageSTLResource = function (clinicId, episodeId, messageId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/messages/:messageId/media/:name', {
                clinicId: clinicId,
                episodeId: episodeId,
                associateProfessionalId: associateProfessionalId,
                messageId: messageId
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getEpisodeOfCareMetricsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getEpisodeOfCareMetricsResource = function (clinicId, episodeId, associateProfessionalId) {
            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/metrics/', {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                episodeId: episodeId
            }, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPrescriptionsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPrescriptionsResource = function (clinicId, episodeId, associateProfessionalId) {
            var path = '/clinics/:clinicId/episodes/:episodeId/prescriptions/:prescriptionId';
            return $resource(apiPath + path, {
                clinicId: clinicId,
                associateProfessionalId: associateProfessionalId,
                episodeId: episodeId
            }, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                },
                patch: {
                    method: 'PATCH'
                },
                print: {
                    url: apiPath + path + '/print',
                    method: 'GET',
                    isArray: false
                }
            });
        };
        this.getClinicianEvaluationsResource = function (clinicId, episodeId) {
            var path = '/clinics/:clinicId/episodes/:episodeId/clinician-evaluations/:clinicianEvaluationId';
            return $resource(apiPath + path, {
                clinicId: clinicId,
                episodeId: episodeId
            }, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExercisesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExercisesResource = function () {
            var params = {
                limit: queryLimit
            };
            if (app === 'admin') {
                angular.extend(params, {
                    ihh: true
                });
            }
            return $resource(apiPath + '/exercises/:exerciseId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseVideoResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseVideoResource = function (exerciseId) {
            return $resource(apiPath + '/exercises/' + exerciseId + '/media/:name', {}, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseAudioResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseAudioResource = function (exerciseId) {
            return $resource(apiPath + '/exercises/' + exerciseId + '/media/:name', {}, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Gets a resource that can be used to save media for the exercise. It is unclear why historicaly we had
         * different methods for different kinds of media, as seen above.
         *
         * @ngdoc method
         * @name getExerciseAudioResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseMediaResource = function (exerciseId) {
            return $resource(apiPath + '/exercises/' + exerciseId + '/media/:name', {}, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getProtocolsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getProtocolsResource = function () {
            var params = {
                limit: queryLimit
            };
            if (app === 'admin') {
                angular.extend(params, {
                    ihh: true
                });
            }
            return $resource(apiPath + '/protocols/:protocolId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseTemplatesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseTemplatesResource = function () {
            var params = {
                limit: queryLimit
            };
            if (app === 'admin') {
                angular.extend(params, {
                    ihh: true
                });
            }
            return $resource(apiPath + '/exercise-templates/:exerciseTemplateId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseImagesResource = function (exerciseId) {
            return $resource(apiPath + '/exercises/' + exerciseId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * An exercise endpoint for clnics.
         *
         * @ngdoc method
         * @name getClinicExercisesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicExercisesResource = function (callingClinicId) {
            var params = {
                limit: queryLimit,
                callingClinicId: callingClinicId
            };

            return $resource(apiPath + '/clinic/clinics/:callingClinicId/exercises/:exerciseId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * An exercise template endpoint for clnics.
         *
         * @ngdoc method
         * @name getClinicExerciseTemplatesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicExerciseTemplatesResource = function (callingClinicId) {
            var params = {
                limit: queryLimit,
                callingClinicId: callingClinicId
            };

            return $resource(apiPath + '/clinic/clinics/:callingClinicId/exercise-templates/:exerciseTemplateId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * A protocol endpoint for clinics.
         *
         * @ngdoc method
         * @name getClinicProtocolsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicProtocolsResource = function (callingClinicId) {
            var params = {
                limit: queryLimit,
                callingClinicId: callingClinicId
            };

            return $resource(apiPath + '/clinic/clinics/:callingClinicId/protocols/:protocolId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * A resource material endpoint for clinics.
         *
         * @ngdoc method
         * @name getClinicResourceMaterialsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicResourceMaterialsResource = function (callingClinicId) {
            var params = {
                limit: queryLimit,
                callingClinicId: callingClinicId
            };

            return $resource(apiPath + '/clinic/clinics/:callingClinicId/resource-materials/:resourceMaterialId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getClinicImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicImagesResource = function (clinicId) {
            return $resource(apiPath + '/clinics/' + clinicId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getTagsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getTagsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/tags/:id', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Resource for tag types.  Just a get method that returns a list, not a query object.
         * @ngdoc method
         * @name getTagTypessResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getTagTypesResource = function () {
            return $resource(apiPath + '/ops/tag-types', {}, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getResistanceItemsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getResistanceItemsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/resistance-items/:id', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPersonImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPersonImagesResource = function (personId) {
            return $resource(apiPath + '/persons/' + personId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getClinicStaffImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicStaffImagesResource = function (clinicId, clinicStaffId) {
            return $resource(apiPath + '/clinics/' + clinicId + '/staff/' + clinicStaffId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getClinicStaffImageUrl = function (clinicId, clinicStaffId, name) {
            return self.appendMediaParams(apiPath + '/clinics/' + clinicId + '/staff/' + clinicStaffId + '/media/' + name);
        };

        this.getIhhStaffImageUrl = function (staffId, name) {
            return self.appendMediaParams(apiPath + '/staff/' + staffId + '/media/' + name);
        };

        this.getPersonImageUrl = function (id, name) {
            return self.appendMediaParams(apiPath + '/persons/' + id + '/media/' + name);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getIhhStaffImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhStaffImagesResource = function (staffId) {
            return $resource(apiPath + '/staff/' + staffId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getTherapistImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getTherapistImagesResource = function (therapistId) {
            return $resource(apiPath + '/therapists/' + therapistId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPatientImagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientImagesResource = function (clinicId, patientId) {
            return $resource(apiPath + '/clinics/' + clinicId + '/patients/' + patientId + '/media/:name', {
                sessionId: UserSvc.get().session.id
            }, {
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getPatientImageUrl = function (clinicId, patientId, name) {
            return self.appendMediaParams(apiPath + '/clinics/' + clinicId + '/patients/' + patientId + '/media/' + name);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getBackupsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getBackupsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/backups/:name', params, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getRestoresResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getRestoresResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/backups/:name/restores', params, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * The patient products resource
         * @ngdoc method
         * @name getPatientProductsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientProductsResource = function (patientId) {
            return $resource(apiPath + '/patients/' + patientId + '/products', {}, {
                query: {
                    method: 'GET'
                }
            });
        };

        /**
         * The clinic usage resource
         * @ngdoc method
         * @name getClinicUsageResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicUsageResource = function () {
            if (app === 'admin') {
                return $resource(apiPath + '/clinic-plan-usage/:clinicId', {}, {});
            }
            else {
                return $resource(apiPath + '/clinics/:clinicId/clinic-plan-usage', {}, {});
            }
        };

        /**
         * The managed clinic plan resource
         * @ngdoc method
         * @name getManagedClinicPlanResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getManagedClinicPlanResource = function (clinicId) {
            var params = {
                limit: queryLimit
            };
            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }
            return $resource(apiPath + '/managed-clinic-plans/:managedClinicPlanId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * The subscriptions resource
         * @ngdoc method
         * @name getSubscriptionsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getSubscriptionResource = function (patientId, subscriptionId) {
            return $resource(apiPath + '/patients/' + patientId + '/subscriptions/' + subscriptionId, {

            }, {
                query: {
                    method: 'GET'
                },
                save: {
                    method: 'PUT'
                }
            });
        };

        /**
         * The payment methods resource
         * @ngdoc method
         * @name getPaymentMethodResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPaymentMethodResource = function (personId, paymentMethodId) {
            var params = {};
            if (angular.isDefined(personId)) {
                angular.extend(params, {
                    personId: personId
                });
            }
            if (angular.isDefined(paymentMethodId)) {
                angular.extend(params, {
                    paymentMethodId: paymentMethodId
                });
            }
            return $resource(apiPath + '/persons/:personId/payment-methods/:paymentMethodId', params);
        };

        /**
         * TODO: change url when endpoint becomes available
         * The payment methods resource
         * @ngdoc method
         * @name getClinicPaymentMethodResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPaymentMethodResource = function (clinicId, paymentMethodId) {
            var params = {};

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            if (angular.isDefined(paymentMethodId)) {
                angular.extend(params, {
                    paymentMethodId: paymentMethodId
                });
            }

            return $resource(apiPath + '/clinics/:clinicId/payment-methods/:paymentMethodId', params, {
                get: {
                    isArray: true
                }
            });
        };

        /* URLs */

        /**
         * TODO
         * @ngdoc method
         * @name getImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getImageUrl = function (entityKind, entityId, name) {
            return self.appendMediaParams(apiPath + '/' + entityKind + '/' + entityId + '/media/' + name);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseThumbnailUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseThumbnailUrl = function (exercise) {
            return this.getExerciseImageUrl(exercise, exercise ? exercise.thumbnail : null);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseImageUrl = function (exercise, name) {
            return exercise && name ? self.appendMediaParams(apiPath + '/exercises/' + exercise.id + '/media/' + name) : self.getDefaultExerciseThumbnailUrl();
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseVideoUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseVideoUrl = function (exercise, name) {
            return exercise && name ? $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/exercises/' + exercise.id + '/media/' + name)) : null;
        };

        /**
         * This function returns a resource material media url
         * @ngdoc method
         * @name getResourceMaterialMediaUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getResourceMaterialMediaUrl = function (resource, name) {
            return resource && name ? $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/resource-materials/' + resource.id + '/media/' + name)) : null;
        };

        /**
         * This function returns a resource material image url
         * @ngdoc method
         * @name getResourceMaterialImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getResourceMaterialImageUrl = function (resource, name) {
            var type = ResourceMaterialsFactory.getType(resource);
            return resource && name ? self.appendMediaParams(apiPath + '/resource-materials/' + resource.id + '/media/' + name) : self.getDefaultResourceMaterialThumbnailUrl(type);
        };

        /**
         * This function returns a resource material thumbnail url
         * @ngdoc method
         * @name getResourceMaterialThumbnailUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getResourceMaterialThumbnailUrl = function (resource) {
            return this.getResourceMaterialImageUrl(resource, resource ? resource.thumbnail : null);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseAudioUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseAudioUrl = function (exercise, name) {
            return exercise && name ? $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/exercises/' + exercise.id + '/media/' + name)) : null;
        };

        /**
         * TODO
         * @ngdoc method
         * @name getMessageImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getMessageImageUrl = function (clinicId, episodeId, messageId, name) {
            return self.appendMediaParams(apiPath + '/clinics/' + clinicId + '/episodes/' + episodeId + '/messages/' + messageId + '/media/' + name);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getMessageAudioUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getMessageAudioUrl = function (clinicId, episodeId, messageId, name) {
            return $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/clinics/' + clinicId + '/episodes/' + episodeId + '/messages/' + messageId + '/media/' + name));
        };

        function getTemplateMessageUrl(clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return apiPath + '/clinic/clinics/' + clinicId + '/campaigns/' + campaignId + '/episode-templates/' + episodeTemplateId + '/episode-template-messages/' + episodeTemplateMessageId + '/media/' + name;
        }

        /**
         * Returns a URL for a clinic template message video.
         * @ngdoc method
         * @name getTemplateMessageVideoUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getTemplateMessageVideoUrl = function (clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return $sce.trustAsResourceUrl(self.appendMediaParams(getTemplateMessageUrl(clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name)));
        };

        /**
         * Returns a URL for a clinic template message image.
         * @ngdoc method
         * @name getTemplateMessageImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getTemplateMessageImageUrl = function (clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return self.appendMediaParams(getTemplateMessageUrl(clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name));
        };

        /**
         * Returns a URL for a clinic template message audio.
         * @ngdoc method
         * @name getTemplateMessageAudioUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getTemplateMessageAudioUrl = function (clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return $sce.trustAsResourceUrl(self.appendMediaParams(getTemplateMessageUrl(clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name)));
        };

        /**
         * Returns a URL for a clinic message video
         * @ngdoc method
         * @name getMessageVideoUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getMessageVideoUrl = function (clinicId, episodeId, messageId, name) {
            return $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/clinics/' + clinicId + '/episodes/' + episodeId + '/messages/' + messageId + '/media/' + name));
        };

        this.getSafeUrl = function (url) {
            return $sce.trustAsResourceUrl(url);
        };

        /**
         * TODO
         * @ngdoc method
         * @name getPatientEpisodesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientEpisodesResource = function (personId) {
            var params = {
                personId: personId,
                limit: queryLimit
            };
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getExerciseSetsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getExerciseSetsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId/exercise-sets/:exerciseSetId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * TODO
         * @ngdoc method
         * @name getWorkoutsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getWorkoutsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId/exercise-sets/:exerciseSetId/workouts/:workoutId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * @ngdoc method
         * @name getSubMerchantAccountsResource
         * @memberOf ihh-common-web.RestResources
         * @description sets up the default resource for sub-merchant accounts
         * @returns {Object} $resource
         */
        this.getSubMerchantAccountsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/clinics/:clinicId/sub-merchant-accounts/:subMerchantAccountId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                },
                submit: {
                    url: apiPath + '/clinics/:clinicId/sub-merchant-accounts/:subMerchantAccountId/submit',
                    method: 'GET'
                },
                submitUpdate: {
                    url: apiPath + '/clinics/:clinicId/sub-merchant-accounts/:subMerchantAccountId/submit-update',
                    method: 'GET'
                }
            });
        };

        /**
         * Returns a resource for getting patient exercise thumbnails. (Note that the ID in the exercise is actually for a PrescriptionExercise,
         * not an Exercise.
         * @ngdoc method
         * @name getExerciseThumbnailUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientExerciseThumbnailUrl = function (personId, episodeId, exerciseSetId, exercise) {
            return exercise && exercise.thumbnail ? self.appendMediaParams(apiPath + '/patients/' + personId + '/episodes/' + episodeId + '/exercise-sets/' + exerciseSetId + '/exercises/' + exercise.id + '/media/' + exercise.thumbnail) : self.getDefaultExerciseThumbnailUrl();
        };

        /**
         * Returns a resource endpoint for messages, from the patient point of view.
         * @ngdoc method
         * @name getPatientMessagesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientMessagesResource = function (personId, episodeId) {
            var params = {
                limit: queryLimit
            };
            angular.extend(params, {
                personId: personId,
                episodeId: episodeId
            });
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId/messages/:messageId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getPatientMessageImageResource = function (personId, episodeId, messageId) {
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId/messages/:messageId/media/:name', {
                personId: personId,
                episodeId: episodeId,
                messageId: messageId
            });
        };

        this.getPatientMessageAudioResource = function (personId, episodeId, messageId) {
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId/messages/:messageId/media/:name', {
                personId: personId,
                episodeId: episodeId,
                messageId: messageId
            });
        };

        this.getPatientMessageVideoResource = function (personId, episodeId, messageId) {
            return $resource(apiPath + '/patients/:personId/episodes/:episodeId/messages/:messageId/media/:name', {
                personId: personId,
                episodeId: episodeId,
                messageId: messageId
            });
        };

        /**
         * Returns a resource endpoint for persons payment tokens
         * @ngdoc method
         * @name getPatientPaymentTokensResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientPaymentTokensResource = function (patientId) {
            return $resource(apiPath + '/persons/' + patientId + '/payment-tokens', {
                sessionId: UserSvc.get().session.id
            }, {
                search: {
                    method: 'POST'
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic payment tokens
         * @ngdoc method
         * @name getClinicPaymentTokensResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPaymentTokensResource = function (clinicId) {
            return $resource(apiPath + '/clinics/' + clinicId + '/payment-tokens', {}, {
                save: {
                    method: 'POST'
                }
            });
        };

        /**
         * Returns a resource endpoint for subscription terms.
         * @ngdoc method
         * @name getSubscriptionTermResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getSubscriptionTermResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/subscription-term', params, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic plan subcription settings
         * @ngdoc method
         * @name getPricingPlanSettingsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPricingPlanSettingsResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/clinic-plan-subscription-settings', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic plan subcription products
         * @ngdoc method
         * @name getClinicPlanSubscriptionProductsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPlanSubscriptionProductsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/clinic-plan-subscription-products', params, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic plan subcription IHH products
         * @ngdoc method
         * @name getClinicPlanSubscriptionProductsIHHResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPlanSubscriptionProductsIHHResource = function (publicPlan) {
            var params = {
                limit: queryLimit
            };

            if (angular.isDefined(publicPlan)) {
                angular.extend(params, {
                    publicPlan: publicPlan
                });
            }

            return $resource(apiPath + '/clinic-plan-subscription-products/:clinicPlanSubscriptionProductId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a clinic-centric resource endpoint for the clinic current subscription.  GET returns the single clinic plan
         * subscription if it exists.  POST updates the subscription.  (Clinics cannot create their own subscriptions.)
         * @ngdoc method
         * @name getClinicPlanSubscriptionsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPlanSubscriptionsResource = function () {
            return $resource(apiPath + '/clinics/:clinicId/clinic-plan-subscriptions');
        };

        /**
         * Returns a resource endpoint for clinic plan IHH Subscriptions
         * @ngdoc method
         * @name getClinicPlanSubscriptionsIHHResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPlanSubscriptionsIHHResource = function (clinicId, active) {
            var params = {
                limit: queryLimit
            };

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            if (angular.isDefined(active)) {
                angular.extend(params, {
                    active: active
                });
            }

            return $resource(apiPath + '/ops/clinic-plan-subscriptions/:clinicPlanSubscriptionId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic plan IHH Subscriptions
         * @ngdoc method
         * @name getClinicPlanSubscriptionsIHHResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPlanSusbcriptionsEstimateResource = function () {
            var params = {};

            return $resource(apiPath + '/clinics/:clinicId/clinic-plan-dry-runs', params, {
                get: {
                    method: 'POST'
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic plan renewal settings
         * @ngdoc method
         * @name getClinicPlanSubscriptionsIHHResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicPlanRenewalSubscriptionsResource = function () {
            var params = {};

            return $resource(apiPath + '/clinics/:clinicId/clinic-plan-subscriptions/renewal-settings', params, {
                save: {
                    method: 'POST'
                }
            });
        };

        /**
         * Returns a resource endpoint for clinic campaigns
         * @ngdoc method
         * @name getClinicCampaignsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getClinicCampaignsResource = function (clinicId, campaignId) {
            var params = {};

            if (angular.isDefined(clinicId)) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            if (angular.isDefined(campaignId)) {
                angular.extend(params, {
                    campaignId: campaignId
                });
            }

            return $resource(apiPath + '/clinic/clinics/:clinicId/campaigns/:campaignId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getIhhPatientsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/clinics/:clinicId/patients/:patientId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for In Hand Health campaigns
         * @ngdoc method
         * @name getIhhCampaignsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhCampaignsResource = function (campaignId) {
            var params = {

            };

            if (angular.isDefined(campaignId)) {
                angular.extend(params, {
                    campaignId: campaignId
                });
            }

            return $resource(apiPath + '/ops/campaigns/:campaignId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        function getEpisodeTemplateApiPath() {
            return apiPath + '/clinic/clinics/:clinicId/campaigns/:campaignId/episode-templates/:episodeTemplateId';
        }

        function extendEpisodeTemplatePathParams(params, clinicId, campaignId, episodeTemplateId) {
            if (clinicId) {
                angular.extend(params, {
                    clinicId: clinicId
                });
            }

            if (campaignId) {
                angular.extend(params, {
                    campaignId: campaignId
                });
            }

            if (episodeTemplateId) {
                angular.extend(params, {
                    episodeTemplateId: episodeTemplateId
                });
            }
        }

        /**
         * Returns a resource endpoint for EOC Templates
         * @ngdoc method
         * @name getEOCTemplatesResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getEOCTemplatesResources = function (clinicId, campaignId, episodeTemplateId) {
            var params = {};

            extendEpisodeTemplatePathParams(params, clinicId, campaignId, episodeTemplateId);

            return $resource(getEpisodeTemplateApiPath(), params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for EOC Resources
         * @ngdoc method
         * @name getEOCResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getEOCResources = function (clinicId, campaignId, episodeTemplateId, episodeTemplateResourceMaterialId) {
            var params = {};

            extendEpisodeTemplatePathParams(params, clinicId, campaignId, episodeTemplateId);

            if (episodeTemplateResourceMaterialId) {
                angular.extend(params, {
                    episodeTemplateResourceMaterialId: episodeTemplateResourceMaterialId
                });
            }

            return $resource(getEpisodeTemplateApiPath() + '/episode-template-resource-materials/:episodeTemplateResourceMaterialId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for EOC Template Message Media
         * @ngdoc method
         * @name getEOCTemplateMessageMediaResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getEOCTemplateMessageMediaResources = function (clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            var params = {};

            extendEpisodeTemplatePathParams(params, clinicId, campaignId, episodeTemplateId);

            if (episodeTemplateMessageId) {
                angular.extend(params, {
                    episodeTemplateMessageId: episodeTemplateMessageId
                });
            }

            if (name) {
                angular.extend(params, {
                    name: name
                });
            }

            return $resource(getEpisodeTemplateApiPath() + '/episode-template-messages/:episodeTemplateMessageId/media/:name', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for EOC Template Messages
         * @ngdoc method
         * @name getEOCTemplateMessagesResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getEOCTemplateMessagesResources = function (clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId) {
            var params = {};

            extendEpisodeTemplatePathParams(params, clinicId, campaignId, episodeTemplateId);

            if (episodeTemplateMessageId) {
                angular.extend(params, {
                    episodeTemplateMessageId: episodeTemplateMessageId
                });
            }

            return $resource(getEpisodeTemplateApiPath() + '/episode-template-messages/:episodeTemplateMessageId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for EOC Template Prescription Templates
         * @ngdoc method
         * @name getEOCTemplatePrescriptionTemplatesResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getEOCTemplatePrescriptionTemplatesResources = function (clinicId, campaignId, episodeTemplateId, prescriptionId) {
            var params = {};

            extendEpisodeTemplatePathParams(params, clinicId, campaignId, episodeTemplateId);

            if (prescriptionId) {
                angular.extend(params, {
                    prescriptionId: prescriptionId
                });
            }

            return $resource(getEpisodeTemplateApiPath() + '/prescriptions/:prescriptionId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        function getIhhEpisodeTemplateApiPath() {
            return apiPath + '/ops/campaigns/:campaignId/episode-templates/:episodeTemplateId';
        }

        function extendIhhEpisodeTemplatePathParams(params, campaignId, episodeTemplateId) {
            if (campaignId) {
                angular.extend(params, {
                    campaignId: campaignId
                });
            }

            if (episodeTemplateId) {
                angular.extend(params, {
                    episodeTemplateId: episodeTemplateId
                });
            }
        }

        /**
         * Returns a resource endpoint for IHH Episode Templates
         * @ngdoc method
         * @name getIhhEpisodeTemplatesResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhEpisodeTemplatesResources = function (campaignId, episodeTemplateId) {
            var params = {};

            extendIhhEpisodeTemplatePathParams(params, campaignId, episodeTemplateId);

            return $resource(getIhhEpisodeTemplateApiPath(), params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for IHH episode template Resources
         * @ngdoc method
         * @name getIhhResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhResources = function (campaignId, episodeTemplateId, episodeTemplateResourceMaterialId) {
            var params = {};

            extendIhhEpisodeTemplatePathParams(params, campaignId, episodeTemplateId);

            if (episodeTemplateResourceMaterialId) {
                angular.extend(params, {
                    episodeTemplateResourceMaterialId: episodeTemplateResourceMaterialId
                });
            }

            return $resource(getIhhEpisodeTemplateApiPath() + '/episode-template-resource-materials/:episodeTemplateResourceMaterialId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for IHH episode template Message Media
         * @ngdoc method
         * @name getIhhTemplateMessageMediaResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhTemplateMessageMediaResources = function (campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            var params = {};

            extendIhhEpisodeTemplatePathParams(params, campaignId, episodeTemplateId);

            if (episodeTemplateMessageId) {
                angular.extend(params, {
                    episodeTemplateMessageId: episodeTemplateMessageId
                });
            }

            if (name) {
                angular.extend(params, {
                    name: name
                });
            }

            return $resource(getIhhEpisodeTemplateApiPath() + '/episode-template-messages/:episodeTemplateMessageId/media/:name', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        function getTemplateMessageUrl(clinicId, campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return apiPath + '/clinic/clinics/' + clinicId + '/campaigns/' + campaignId + '/episode-templates/' + episodeTemplateId + '/episode-template-messages/' + episodeTemplateMessageId + '/media/' + name;
        }

        function getIhhTemplateMessageMediaUrl(campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            var prefix = apiPath + '/ops/campaigns/' + campaignId + '/episode-templates/' + episodeTemplateId;
            return prefix + '/episode-template-messages/' + episodeTemplateMessageId + '/media/' + name;
        }

        /**
         * Returns a URL for an IHH template message video.
         * @ngdoc method
         * @name getIhhTemplateMessageVideoUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhTemplateMessageVideoUrl = function (campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return $sce.trustAsResourceUrl(self.appendMediaParams(getIhhTemplateMessageMediaUrl(campaignId, episodeTemplateId, episodeTemplateMessageId, name)));
        };

        /**
         * Returns a URL for an IHH template message image.
         * @ngdoc method
         * @name getIhhTemplateMessageImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhTemplateMessageImageUrl = function (campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return self.appendMediaParams(getIhhTemplateMessageMediaUrl(campaignId, episodeTemplateId, episodeTemplateMessageId, name));
        };

        /**
         * Returns a URL for an IHH template message audio.
         * @ngdoc method
         * @name getIddTemplateMessageAudioUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhTemplateMessageAudioUrl = function (campaignId, episodeTemplateId, episodeTemplateMessageId, name) {
            return $sce.trustAsResourceUrl(self.appendMediaParams(getIhhTemplateMessageMediaUrl(campaignId, episodeTemplateId, episodeTemplateMessageId, name)));
        };

        /**
         * Returns a resource endpoint for IHH episode template Messages
         * @ngdoc method
         * @name getIhhTemplateMessagesResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhTemplateMessagesResources = function (campaignId, episodeTemplateId, episodeTemplateMessageId) {
            var params = {};

            extendIhhEpisodeTemplatePathParams(params, campaignId, episodeTemplateId);

            if (episodeTemplateMessageId) {
                angular.extend(params, {
                    episodeTemplateMessageId: episodeTemplateMessageId
                });
            }

            return $resource(getIhhEpisodeTemplateApiPath() + '/episode-template-messages/:episodeTemplateMessageId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource endpoint for IHH episode template Prescription Templates
         * @ngdoc method
         * @name getIhhTemplatePrescriptionTemplatesResources
         * @memberOf ihh-common-web.RestResources
         */
        this.getIhhTemplatePrescriptionTemplatesResources = function (campaignId, episodeTemplateId, prescriptionId) {
            var params = {};

            extendIhhEpisodeTemplatePathParams(params, campaignId, episodeTemplateId);

            if (prescriptionId) {
                angular.extend(params, {
                    prescriptionId: prescriptionId
                });
            }

            return $resource(getIhhEpisodeTemplateApiPath() + '/prescriptions/:prescriptionId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a url for a patient message image.
         * @ngdoc method
         * @name getPatientMessageImageUrl
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientMessageImageUrl = function (personId, episodeId, message, name) {
            if (!personId || !episodeId || !message || !message.id || !name) {
                return null;
            }

            return self.appendMediaParams(apiPath + '/patients/' + personId + '/episodes/' + episodeId + '/messages/' + message.id + '/media/' + name);
        };

        this.getPatientMessageAudioUrl = function (personId, episodeId, message, name) {
            if (!personId || !episodeId || !message || !message.id || !name) {
                return null;
            }

            return $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/patients/' + personId + '/episodes/' + episodeId + '/messages/' + message.id + '/media/' + name));
        };

        this.getPatientMessageVideoUrl = function (personId, episodeId, message, name) {
            if (!personId || !episodeId || !message || !message.id || !name) {
                return null;
            }

            return $sce.trustAsResourceUrl(self.appendMediaParams(apiPath + '/patients/' + personId + '/episodes/' + episodeId + '/messages/' + message.id + '/media/' + name));
        };

        /**
         * Returns a resource for CRUD on resource materials
         * @ngdoc method
         * @name getResourceMaterialsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getResourceMaterialsResource = function () {
            var params = {
                limit: queryLimit
            };
            if (app === 'admin') {
                angular.extend(params, {
                    ihh: true
                });
            }

            return $resource(apiPath + '/resource-materials/:resourceMaterialId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource for CRUD on episode resource materials
         * @ngdoc method
         * @name getEpisodeResourceMaterialsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getEpisodeResourceMaterialsResource = function (associateProfessionalId) {
            var params = {
                associateProfessionalId: associateProfessionalId
            };

            return $resource(apiPath + '/clinics/:clinicId/episodes/:episodeId/episode-resource-materials/:episodeResourceMaterialId', params, {
                query: {
                    isArray: false
                },
                save: {
                    method: 'POST'
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource for CRUD operations on resource material media items
         * @ngdoc method
         * @name getResourceMaterialMediaResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getResourceMaterialMediaResource = function (resourceMaterialId, associateProfessionalId) {
            var params = {
                associateProfessionalId: associateProfessionalId
            };

            return $resource(apiPath + '/resource-materials/' + resourceMaterialId + '/media/:name', params, {
                update: {
                    method: 'PUT'
                },
                save: {
                    method: 'POST'
                }
            });
        };

        this.getClinicRtcResource = function (clinicId, patientId) {
            var path = '/clinics/:clinicId/patients/:patientId/rtc-sessions/:rtcSessionId';
            return $resource(apiPath + path, {
                clinicId: clinicId,
                patientId: patientId
            }, {
                query: {
                    isArray: false
                }
            });
        };

        this.getPatientRtcResource = function (personId) {
            var path = '/patients/:personId/rtc-sessions/:rtcSessionId';
            return $resource(apiPath + path, {
                personId: personId
            }, {
                query: {
                    isArray: false
                }
            });
        };

        this.getClinicRtcRoomResource = function (clinicId, episodeId) {
            var path = '/clinics/:clinicId/episodes/:episodeId/rtc-rooms/:roomId';
            return $resource(apiPath + path, {
                clinicId: clinicId,
                episodeId: episodeId
            }, {
                query: {
                    isArray: false
                }
            });
        };

        this.getPatientRtcRoomResource = function (personId, episodeId) {
            var path = '/patients/:personId/episodes/:episodeId/rtc-rooms/:roomId';
            return $resource(apiPath + path, {
                personId: personId,
                episodeId: episodeId
            }, {
                query: {
                    isArray: false
                }
            });
        };

        this.getCareGroupResource = function (clinicId, careGroupId) {
            var path = '/clinic/clinics/:clinicId/care-groups/:careGroupId';
            var config = {
                clinicId: clinicId
            };

            if (careGroupId) {
                config.careGroupId = careGroupId;
            }

            return $resource(apiPath + path, config, {
                update: {
                    method: 'PUT'
                },
                query: {
                    isArray: false
                }
            });
        };

        this.getCareGroupMessagesResource = function (clinicId, careGroupId) {
            var path = '/clinic/clinics/:clinicId/care-groups/:careGroupId/messages';
            var config = {
                clinicId: clinicId,
                careGroupId: careGroupId
            };

            return $resource(apiPath + path, config, {
                update: {
                    method: 'PUT'
                },
                query: {
                    isArray: false
                }
            });
        };

        this.getCareGroupMessageMediaResource = function (clinicId, careGroupId, careGroupMessageId, name) {
            var path = '/clinic/clinics/:clinicId/care-groups/:careGroupId/messages/:careGroupMessageId/media/:name';
            var config = {
                clinicId: clinicId,
                careGroupId: careGroupId,
                careGroupMessageId: careGroupMessageId,
                name: name
            };

            return $resource(apiPath + path, config, {
                update: {
                    method: 'PUT'
                },
                query: {
                    isArray: false
                }
            });
        };

        this.getCareGroupResourceMaterialsResource = function (clinicId, careGroupId) {
            var path = '/clinic/clinics/:clinicId/care-groups/:careGroupId/resource-materials/:careGroupResourceMaterialId';
            var config = {
                clinicId: clinicId,
                careGroupId: careGroupId
            };

            return $resource(apiPath + path, config, {
                update: {
                    method: 'PUT'
                },
                query: {
                    isArray: false
                }
            });
        };

        this.getCareGroupPrescriptionsResource = function (clinicId, careGroupId) {
            var path = '/clinic/clinics/:clinicId/care-groups/:careGroupId/prescriptions/:prescriptionId';
            var config = {
                clinicId: clinicId,
                careGroupId: careGroupId
            };

            return $resource(apiPath + path, config, {
                update: {
                    method: 'PUT'
                },
                query: {
                    isArray: false
                }
            });
        };

        this.getCareGroupStaffResource = function (clinicId, careGroupId) {
            var path = '/clinic/clinics/:clinicId/care-groups/:careGroupId/staff';
            var config = {
                clinicId: clinicId,
                careGroupId: careGroupId
            };

            return $resource(apiPath + path, config, {
                assign: {
                    method: 'POST',
                    url: apiPath + '/clinic/clinics/' + clinicId + '/care-groups/' + careGroupId + '/staff/assign'
                },
                unassign: {
                    method: 'POST',
                    url: apiPath + '/clinic/clinics/' + clinicId + '/care-groups/' + careGroupId + '/staff/unassign'
                }
            });
        };

        this.getCareGroupMessageMediaUrl = function (clinicId, careGroupId, messageId, name) {
            return apiPath + '/clinic/clinics/' + clinicId + '/care-groups/' + careGroupId + '/messages/' + messageId + '/media/' + name;
        };

        this.getCareGroupMessageImageUrl = function (clinicId, careGroupId, messageId, name) {
            return self.appendMediaParams(self.getCareGroupMessageMediaUrl(clinicId, careGroupId, messageId, name));
        };

        this.getCareGroupMessageAudioUrl = function (clinicId, careGroupId, messageId, name) {
            return self.getSafeUrl(self.appendMediaParams(self.getCareGroupMessageMediaUrl(clinicId, careGroupId, messageId, name)));
        };

        this.getCareGroupMessageVideoUrl = function (clinicId, careGroupId, messageId, name) {
            return self.getSafeUrl(self.appendMediaParams(self.getCareGroupMessageMediaUrl(clinicId, careGroupId, messageId, name)));
        };

        this.getCareGroupMessagePdfUrl = function (clinicId, careGroupId, messageId, name) {
            return self.appendMediaParams(self.getCareGroupMessageMediaUrl(clinicId, careGroupId, messageId, name));
        };

        this.getCareGroupMessageStlUrl = function (clinicId, careGroupId, messageId, name) {
            return self.appendMediaParams(self.getCareGroupMessageMediaUrl(clinicId, careGroupId, messageId, name));
        };

        /**
         * Returns a resource for CRUD on patient imports.
         * @ngdoc method
         * @name getPatientImportsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientImportsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/patient-imports/:patientImportId', params, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * Returns a resource for patient import uploads.  POST only.
         * @ngdoc method
         * @name getPatientImportUploadsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientImportUploadsResource = function () {
            return $resource(apiPath + '/clinics/:clinicId/patient-import-uploads');
        };

        /**
         * Returns a resource to get patient import detailss.
         * @ngdoc method
         * @name getPatientImportDetailsResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getPatientImportDetailsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/clinics/:clinicId/patient-imports/:patientImportId/details/:patientImportDetailId', params, {
                query: {
                    isArray: false
                }
            });
        };

        /**
         * Returns a resource for measures.
         * @ngdoc method
         * @name getMeasuresResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getMeasuresResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/ops/measures/:measureId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /**
         * Returns a resource for episode types.
         * @ngdoc method
         * @name getEpisodeTypesResource
         * @memberOf ihh-common-web.RestResources
         */
        this.getEpisodeTypesResource = function () {
            var params = {
                limit: queryLimit
            };
            return $resource(apiPath + '/ops/episode-types/:episodeTypeId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getLogsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/remote-logs', params, {
                query: {
                    isArray: false
                }
            });
        };

        this.getPaymentTransactionsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/payment-transactions', params, {
                query: {
                    isArray: false
                }
            });
        };

        this.getPatientSimulationsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/patient-simulations/:patientSimulationId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        /*
         * Queries for all patient strategies.
         *
         * Notice this endpoint is unusual in that it returns a plain list, not query result.
         */
        this.getPatientSimulationStrategiesResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/patient-simulation-strategies', params);
        };

        this.getPatientSimulationImagesResource = function (patientSimulationId) {
            return $resource(apiPath + '/patient-simulations/:patientSimulationId/media/:name', {
                patientSimulationId: patientSimulationId
            });
        };

        this.getIntegrationsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/integrations/:integrationId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getClinicIntegrationsResource = function (clinicId) {
            var params = {
                clinicId: clinicId
            };

            return $resource(apiPath + '/clinic/clinics/:clinicId/integrations/:integrationId', params, {
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getClinicOAuth2SyncIntegrationResource = function (clinicId) {
            var params = {
                clinicId: clinicId
            };

            return $resource(apiPath + '/clinic/clinics/:clinicId/oauth2-sync', params, {});
        };

        this.getOAuth2ClientsResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/oauth2-clients/:oauth2ClientId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getWebhookSinksResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/webhook-sinks/:webhookSinkId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getClientInfoResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/client-info/:clientId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getEventTypesResource = function () {
            var params = {
                limit: queryLimit
            };

            return $resource(apiPath + '/event-types', params, {
                query: {
                    isArray: false
                }
            });
        };

        this.getEventSubscriptionResource = function () {
            var params = {
                isInHandHealth: true,
                limit: queryLimit
            };

            return $resource(apiPath + '/ops/event-subscriptions/:eventSubscriptionId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };

        this.getClinicEventSubscriptionResource = function (clinicId) {
            var params = {
                limit: queryLimit,
                clinicId: clinicId
            };

            return $resource(apiPath + '/clinics/:clinicId/event-subscriptions/:eventSubscriptionId', params, {
                query: {
                    isArray: false
                },
                update: {
                    method: 'PUT'
                }
            });
        };
    }
})();
